const $ = require("jquery");
const _ = require("lodash");
const {Foundation} = window;

module.exports = class ExpiesForm {
    constructor(id, utmCookies) {
        this.id = id;
        this.setupForm();
        utmCookies.initForm(this.getForm()[0]);
    }

    setupForm() {
        new Foundation.Abide(this.getForm());

        this.getForm()
            .on("forminvalid.zf.abide", () => {
                $(`#${this.id}-error-summary`).css('display', 'unset');
            })
            .on("formvalid.zf.abide", () => this.submit())
            .on("submit", e => {
                e.preventDefault();
                const scrollTop = $('[data-component="expies-form"]')[0].getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
                $("html, body").animate({ scrollTop: scrollTop }, "slow");
            });
    }

    getForm() {
        return $(`#${this.id}`);
    }

    serializeFormData() {
        return _.reduce(
            this.getForm().serializeArray(),
            (data, field) => _.set(data, field.name, field.value),
            {}
        );
    }

    async submitToGoogleSheets(data) {
        const formData = new FormData();
        formData.append("entry.2090713333", data['FirstName']);
        formData.append("entry.731610243", data['LastName']);
        formData.append("entry.368037659", data['Country']);
        formData.append("entry.220670875", data['Email']);
        formData.append("entry.1839689990", data['Title']);
        formData.append("entry.1636290680", data['Company']);
        formData.append("entry.1549704979", data['onBehalfOfIterableCustomer']);
        formData.append("entry.1286208479", data['Referrer_Name__c']);
        formData.append("entry.749183411", data['Referrer_Email__c']);
        formData.append("entry.1765876174", data['Referrer_Company__c']);
        formData.append("entry.535011306", data['marketoTempUseStringField1']);
        formData.append("entry.194630924", data['NomineeType']);
        formData.append("entry.1904006021", data['NomineeDescription']);
        formData.append("entry.980951325", data['Highlights']);
        formData.append("entry.227078320", data['Challenges']);
        formData.append("entry.2040929530", data['Solution']);
        formData.append("entry.1583991453", data['Results']);
        formData.append("entry.837709258", data['Additional']);
        formData.append("entry.817977830", data['TermsAndConditions']);
        formData.append("entry.492605548", data['marketingConsent']);

        try {
            await fetch(
                "https://docs.google.com/forms/u/2/d/e/1FAIpQLScgeoX4tDrgkZj46HSMke3rSCjMO50QepeVjta69gbM7XxK-Q/formResponse",
                {
                    method: 'POST',
                    mode: 'no-cors',
                    body: formData
                }
            );
        } catch (e) {
            // Nothing to do in here
        }
    }

    getData() {
        const data = this.serializeFormData();

        if (data['marketingConsent'] !== 'true') {
            data['marketingConsent'] = 'false';
        }

        if (data['onBehalfOfIterableCustomer'] !== 'true') {
            data['onBehalfOfIterableCustomer'] = 'false';
        }

        if (data['marketoTempUseStringField1'] === 'Next-Gen Innovators Award') {
            data['Highlights'] = '';
            data['Challenges'] = '';
            data['Solution'] = '';
            data['Results'] = '';
        } else {
            data['NomineeType'] = '';
            data['NomineeDescription'] = '';
        }

        return data;
    }

    getLoading() {
        return $(`#${this.id}-loading`);
    }

    getSuccess() {
        return $(`#${this.id}-success`);
    }

    submit() {
        const $form = this.getForm();
        const $loading = this.getLoading();
        const $success = this.getSuccess();

        $form.css('display', 'none');
        $loading.css('display', 'unset');

        const data = this.getData();

        this.submitToGoogleSheets(data);

        window.MktoForms2.loadForm('https://go.iterable.com', "723-YAV-537", 1206, function (form) {
            const mktoStyleLoaded = document.querySelectorAll('#mktoStyleLoaded');
            if (mktoStyleLoaded.length > 1) {
                for (let i = 1; i < mktoStyleLoaded.length; i++) {
                    mktoStyleLoaded[i].remove();
                }
            }

            form.vals(data);
            form.addHiddenFields(data);

            form.onValidate(valid => {
                if (!valid) {
                    alert("Could not submit form!");
                } else {
                    console.log('Expies form valid!');
                }
            });

            form.onSuccess(() => {
                console.log("Expies form submitted!");
                $loading.css('display', 'none');
                $success.css('display', 'unset');
                $("html, body").animate({ scrollTop: 0 }, "slow");
                return false;
            });

            form.submit();
        });
    }
}
